import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
  selector: 'app-pss-warn',
  imports: [CommonModule],
  templateUrl: './pss-warn.component.html',
  styleUrl: './pss-warn.component.css'
})
export class PssWarnComponent {
  @Input() text : string = 'แจ้งเตือน!'
  @Input() detail: string = 'กรุณากรอกข้อมูลให้ครบถ้วน'
  @Input() timeIn : number = 3000
  @Input() isButtonConfirm : boolean = false
  @Input() isButtonClose : boolean = true
  @Input() language : "TH" | "EN" = "TH"
  /** ถ้าส่งมา จะใช้แทนสติกเกอร์ PSS ปกติ */
  @Input() imageSrc: string = ''

  @Output() close = new EventEmitter<boolean>()
  @Output() submit = new EventEmitter<boolean>()

  constructor() { }

  ngOnInit(): void {
    if(!this.isButtonConfirm && !this.isButtonClose) return this.onCountdown()
  }

  onCountdown() {
    setTimeout(() => {
        this.close.emit(false);
      },
      this.timeIn
    );
  }
  
  onConfirm() {
    this.submit.emit(false)
  }
  onClose() {
    this.close.emit(false)
  }
}